var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDebitNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FF6060",
    opacity: 0.1,
    width: 36,
    height: 36,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6h24v24H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6060",
    fillRule: "nonzero",
    d: "m15 19.59 8.607-8.607 1.414 1.414-8.607 8.607H24v2H13v-11h2v7.585z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitNew);
export default __webpack_public_path__ + "static/media/debit-new.f79c761154cea4004d10af7eb838def6.svg";
export { ForwardRef as ReactComponent };